/**
 * @desc 解除绑定交货单
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export type Response = defs.srm.Response;
export function request(boxCode: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/srm/supplierBox/unBindDono/${boxCode}`, {
      method: "PUT",

      ...options,
    }),
  );
}
